export class TradeStatisticDto {
  currency: string;
  exchange: string;
  valueDate: any;
  state: number;
  address: string;
  amount: string;
}
